"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (array) {
  return array[array.length - 1];
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/lib/utils/getLastElement.js
// module id = 1827
// module chunks = 0